import _extends from "@babel/runtime/helpers/extends";
import '../../css-tokens';
import React, { forwardRef } from 'react';
import cx from 'classnames';
import system, { getLogo } from '../../system';
import styles from './index.module.css';
const SYSTEM_PROPS = ['borderRadiusProps', 'flexProps', 'floatProps', 'heightProps', 'marginProps', 'positioningProps', 'widthProps'];
const normalizeName = name => {
  if (name && name.includes('.')) {
    return {
      scope: name.split('.')[0],
      name: name.split('.')[1]
    };
  }
  return {
    scope: undefined,
    name
  };
};
const Logo = /*#__PURE__*/function () {
  const Logo = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      name,
      version,
      extension,
      verticalAlign,
      alt,
      ...props
    } = _ref;
    const obj = normalizeName(name);
    const logo = getLogo(obj.name, obj.scope, version);
    const [className, style, rest] = system(props, SYSTEM_PROPS);
    const classnames = {
      [styles.root]: true,
      [styles.baseline]: verticalAlign === 'baseline',
      [styles.bottom]: verticalAlign === 'bottom',
      [styles.inherit]: verticalAlign === 'inherit',
      [styles.middle]: verticalAlign === 'middle',
      [styles.sub]: verticalAlign === 'sub',
      [styles.super]: verticalAlign === 'super',
      [styles.textBottom]: verticalAlign === 'text-bottom',
      [styles.textTop]: verticalAlign === 'text-top',
      [styles.top]: verticalAlign === 'top',
      [styles.unset]: verticalAlign === 'unset'
    };
    if (logo[extension]) {
      return /*#__PURE__*/React.createElement("img", _extends({
        className: cx(classnames, className),
        style: style,
        ref: ref,
        src: `${logo[extension]}?v=${version || 1}`,
        alt: alt || logo.alt
      }, rest));
    }
    return null;
  });
  Logo.displayName = 'Logo';
  Logo.identifier = Logo.displayName; // used in docs website
  Logo.clonableProps = SYSTEM_PROPS;
  Logo.defaultProps = {
    extension: 'svg',
    verticalAlign: 'middle',
    maxWidth: 'full',
    height: 'auto',
    width: 'auto'
  };
  return Logo;
}();
export default Logo;